<template>
    <div class="page-content-wrapper">
        <div :class="'page-content light-blue-bg ' + className" :style="initStyle" :id="id" v-if="id">
            <slot></slot>
        </div>
        <div :class="'page-content light-blue-bg ' + className" :style="initStyle" v-else>
            <slot></slot>
        </div>
	</div>
</template>
<script>
export default {
    props: ['className', 'id'],
    computed: {
        initStyle () {
            if (this.className) return ''
            else return 'padding-bottom:80px'
        }
    }
}
</script>
